module.exports = __webpack_public_path__ + "static/media/partner13.4e0377fe.jpg";